const HomeQRModal = ({ qr, download }) => {
    return (
        <div className="modal fade home-qr-modal" id="modalQR" tabIndex="-1" aria-labelledby="modalQRLabel" aria-hidden="true">
            <div className="modal-dialog modal-dialog-centered modal-lg">
                <div className="modal-content">
                    <div className="modal-header">
                        <h2 className="modal-title fs-5 titleModalQr" id="modalQRLabel">Código QR de tu carta</h2>
                        <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Cerrar"></button>
                    </div>
                    <div className="modal-body divQr">
                        {qr ? (
                            <img src={qr} alt="Código QR de la carta" />
                        ) : (
                            <p className="text-muted mb-0">Generando QR...</p>
                        )}
                    </div>
                    <div className="modal-footer">
                        <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">Cerrar</button>
                        <button type="button" className="btn btn-primary" data-bs-dismiss="modal" onClick={download} disabled={!qr}>
                            Descargar
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default HomeQRModal;
